import { TextInput } from "@carbon/react";

export const View = (props) => {
  return (
    <div className="input-container">
      <TextInput
        helperText={props.helperText}
        id={props.id}
        invalidText={props.invalidText}
        labelText={props.label}
        placeholder={props.placeholder}
        {...props}
        className={`${props.className} switchapp-themed`}
      />
    </div>
  );
};
